<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>location_on</mat-icon>
      Event Locations
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section mat-dialog-content>
    <search-text (search)="setSearch($event)"></search-text>
    @if (!loading) {
      <mat-table [dataSource]="DataSource">
        <ng-container matColumnDef="title">
          <mat-header-cell *matHeaderCellDef>Title</mat-header-cell>
          <mat-cell *matCellDef="let row">{{row.title}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="actions">
            <button
              (click)="editItem()"
              mat-icon-button
              matTooltip="Add location."
              >
              <mat-icon>add</mat-icon>
            </button>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="actions">
            @if (!!row.id) {
              <button
                (click)="editItem(row)"
                mat-icon-button
                matTooltip="Edit location."
                >
                <mat-icon>edit</mat-icon>
              </button>
            }
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <div class="mat-row" *matNoDataRow>
          <div class="mat-cell no-data-cell">No locations avalible</div>
        </div>
      </mat-table>
    }
    @if (PageEvent) {
      <mat-paginator
        (page)="DataSource.loadWithPageEvent($event)"
        [length]="PageEvent.length"
        [pageIndex]="PageEvent.pageIndex"
        [pageSize]="PageEvent.pageSize"
      ></mat-paginator>
    }
  </section>
</section>
